import type {
    BioscopeRestart as BioscopeRestartDto,
    BioscopeRouterRestart as BioscopeRouterRestartDto,
} from '@/services/types';

import type { BioscopeRestart, BioscopeRouterRestart } from './types';

export function toBioscopeRestart(dto: BioscopeRestartDto): BioscopeRestart {
    return {
        isDone: dto.isDone,
        updatedAt: dto.updatedAt,
        message: dto.message ?? null,
        shutdownSmsId: dto.shutdownSmsId ?? null,
        startSmsId: dto.startSmsId ?? null,
    };
}

export function toBioscopeRouterRestart(dto: BioscopeRouterRestartDto): BioscopeRouterRestart {
    return {
        isDone: dto.isDone,
        updatedAt: dto.updatedAt,
        message: dto.message ?? null,
        rebootSmsId: dto.rebootSmsId ?? null,
        rebootResponseId: dto.rebootResponseId ?? null,
    };
}
